// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--iS4gW";
export var largeTitle = "styles-module--largeTitle--3H4DE";